import { render, staticRenderFns } from "./costHelpSpa.vue?vue&type=template&id=30aa38c1&"
import script from "./costHelpSpa.vue?vue&type=script&lang=js&"
export * from "./costHelpSpa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30aa38c1')) {
      api.createRecord('30aa38c1', component.options)
    } else {
      api.reload('30aa38c1', component.options)
    }
    module.hot.accept("./costHelpSpa.vue?vue&type=template&id=30aa38c1&", function () {
      api.rerender('30aa38c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Iutk1RwNx0Hc/JS/comp/costHelpSpa.vue"
export default component.exports